
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watchEffect, watch } from 'vue'

import { DoubleRightOutlined, DoubleLeftOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import f10Api from '@/api/f10Api'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
// import func from "vue-temp/vue-editor-bridge";
const myColumns: any = {
  ybqy: [
    {
      title: '现金流量表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '经营活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '销售商品、提供劳务收到的现金',
      dataIndex: 'GoodsSaleServiceRenderCash',
      key: 'GoodsSaleServiceRenderCash',
      indentStep: 1
    },
    {
      title: '收到的税收返还',
      dataIndex: 'TaxLevyRefund',
      key: 'TaxLevyRefund',
      indentStep: 1
    },
    {
      title: ' 收到其他与经营活动有关的现金',
      dataIndex: 'OtherCashInRelatedOperate',
      key: 'OtherCashInRelatedOperate',
      indentStep: 1
    },
    {
      title: '经营活动现金流入小计',
      dataIndex: 'SubtotalOperateCashInflow',
      key: 'SubtotalOperateCashInflow'
    },
    {
      title: '购买商品、接受劳务支付的现金',
      dataIndex: 'GoodsServicesCashPaid',
      key: 'GoodsServicesCashPaid',
      indentStep: 1
    },
    {
      title: '支付给职工以及为职工支付的现金',
      dataIndex: 'StaffBehalfPaid',
      key: 'StaffBehalfPaid',
      indentStep: 1
    },
    {
      title: '支付的各项税费',
      dataIndex: 'AllTaxesPaid',
      key: 'AllTaxesPaid',
      indentStep: 1
    },
    {
      title: '支付其他与经营活动有关的现金',
      dataIndex: 'OtherOperateCashPaid',
      key: 'OtherOperateCashPaid',
      indentStep: 1
    },
    {
      title: '经营活动现金流出小计',
      dataIndex: 'SubtotalOperateCashOutflow',
      key: 'SubtotalOperateCashOutflow'
    },
    {
      title: '经营活动产生的现金流量净额',
      dataIndex: 'NetOperateCashFlow',
      key: 'NetOperateCashFlow'
    },
    {
      title: '投资活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '收回投资收到的现金',
      dataIndex: 'InvestWithdrawalCash',
      key: 'InvestWithdrawalCash'
    },
    {
      title: '取得投资收益收到的现金',
      dataIndex: 'Investproceeds',
      key: 'Investproceeds',
      indentStep: 1
    },
    {
      title: '处置固定资产、无形资产和其他长期资产收回的现金净额',
      dataIndex: 'FixIntanOtherAssetDispoCash',
      key: 'FixIntanOtherAssetDispoCash',
      indentStep: 1
    },
    {
      title: '收到的其他与投资活动有关的现金',
      dataIndex: 'OtherCashFromInvestAct',
      key: 'OtherCashFromInvestAct',
      indentStep: 1
    },
    {
      title: '投资活动现金流入小计',
      dataIndex: 'SubtotalInvestCashInflow',
      key: 'SubtotalInvestCashInflow'
    },
    {
      title: '购建固定资产、无形资产和其他长期资产所支付的现金',
      dataIndex: 'FixIntanOtherAssetAcquiCash',
      key: 'FixIntanOtherAssetAcquiCash',
      indentStep: 1
    },
    {
      title: '投资支付的现金',
      dataIndex: 'InvestCashPaid',
      key: 'InvestCashPaid',
      indentStep: 1
    },
    {
      title: '取得子公司及其他营业单位支付的现金净额',
      dataIndex: 'NetCashFromSubCompany',
      key: 'NetCashFromSubCompany',
      indentStep: 1
    },
    {
      title: '支付其他与投资活动有关的现金',
      dataIndex: 'OtherCashToInvestAct',
      key: 'OtherCashToInvestAct',
      indentStep: 1
    },
    {
      title: '投资活动现金流出小计',
      dataIndex: 'SubtotalInvestCashOutflow',
      key: 'SubtotalInvestCashOutflow'
    },
    {
      title: '投资活动产生的现金流量净额',
      dataIndex: 'NetInvestCashFlow',
      key: 'NetInvestCashFlow'
    },
    {
      title: '筹资活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '吸收投资收到的现金',
      dataIndex: 'CashFromInvest',
      key: 'CashFromInvest',
      indentStep: 1
    },
    {
      title: '其中:子公司吸收少数股东投资收到的现金',
      dataIndex: 'CashFromMinoSInvestSub',
      key: 'CashFromMinoSInvestSub',
      indentStep: 1
    },
    {
      title: '取得借款收到的现金',
      dataIndex: 'CashFromBorrowing',
      key: 'CashFromBorrowing',
      indentStep: 1
    },
    {
      title: '收到其他与筹资活动有关的现金',
      dataIndex: 'OtherFinanceActCash',
      key: 'OtherFinanceActCash',
      indentStep: 1
    },
    {
      title: '筹资活动现金流入小计',
      dataIndex: 'SubtotalFinanceCashInflow',
      key: 'SubtotalFinanceCashInflow'
    },
    {
      title: '偿还债务支付的现金',
      dataIndex: 'BorrowingRepayment',
      key: 'BorrowingRepayment',
      indentStep: 1
    },
    {
      title: '分配股利、利润或偿付利息支付的现金',
      dataIndex: 'DividendInterestPayment',
      key: 'DividendInterestPayment',
      indentStep: 1
    },
    {
      title: '其中:子公司支付给少数股东的股利、利润',
      dataIndex: 'ProceedsFromSubToMinoS',
      key: 'ProceedsFromSubToMinoS',
      indentStep: 1
    },
    {
      title: '支付其他与筹资活动有关的现金',
      dataIndex: 'OtherFinanceActPayment',
      key: 'OtherFinanceActPayment',
      indentStep: 1
    },
    {
      title: '筹资活动现金流出小计',
      dataIndex: 'SubtotalFinanceCashOutflow',
      key: 'SubtotalFinanceCashOutflow'
    },
    {
      title: '筹资活动产生的现金流量净额',
      dataIndex: 'NetFinanceCashFlow',
      key: 'NetFinanceCashFlow'
    },
    {
      title: '汇率变动对现金及现金等价物的影响',
      dataIndex: 'ExchanRateChangeEffect',
      key: 'ExchanRateChangeEffect',
      indentStep: 1
    },
    {
      title: '现金及现金等价物净增加额',
      dataIndex: 'CashEquivalentIncrease',
      key: 'CashEquivalentIncrease',
      indentStep: 1
    },
    {
      title: '加:期初现金及现金等价物余额',
      dataIndex: 'BeginPeriodCash',
      key: 'BeginPeriodCash',
      indentStep: 1
    },
    {
      title: '期末现金及现金等价物余额',
      dataIndex: 'EndPeriodCashEquivalent',
      key: 'EndPeriodCashEquivalent'
    },
    {
      title: '补充资料',
      dataIndex: '',
      key: ''
    },
    {
      title: '净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit',
      indentStep: 1
    },
    {
      title: '资产减值准备',
      dataIndex: 'AssetsDepreciationReserves',
      key: 'AssetsDepreciationReserves',
      indentStep: 1
    },
    {
      title: '固定资产和投资性房地产折旧',
      dataIndex: 'AssetDepreciation',
      key: 'AssetDepreciation',
      indentStep: 1
    },
    {
      title: '其中:固定资产折旧、油气资产折耗、生产性生物资产折旧',
      dataIndex: 'FixedAssetDepreciation',
      key: 'FixedAssetDepreciation',
      indentStep: 1
    },
    {
      title: '无形资产摊销',
      dataIndex: 'IntangibleAssetAmortization',
      key: 'IntangibleAssetAmortization',
      indentStep: 1
    },
    {
      title: '长期待摊费用摊销',
      dataIndex: 'DeferredExpenseAmort',
      key: 'DeferredExpenseAmort',
      indentStep: 1
    },
    {
      title: '处置固定资产、无形资产和其他长期资产的损失',
      dataIndex: 'FixIntanOtherAssetDispoLoss',
      key: 'FixIntanOtherAssetDispoLoss',
      indentStep: 1
    },
    {
      title: '固定资产报废损失',
      dataIndex: 'FixedAssetScrapLoss',
      key: 'FixedAssetScrapLoss',
      indentStep: 1
    },
    {
      title: '公允价值变动损失',
      dataIndex: 'LossFromFairValueChanges',
      key: 'LossFromFairValueChanges',
      indentStep: 1
    },
    {
      title: '财务费用',
      dataIndex: 'FinancialExpense',
      key: 'FinancialExpense',
      indentStep: 1
    },
    {
      title: '投资损失',
      dataIndex: 'InvestLoss',
      key: 'InvestLoss',
      indentStep: 1
    },
    {
      title: '递延所得税',
      dataIndex: 'DeferedTaxAsset',
      key: 'DeferedTaxAsset',
      indentStep: 1
    },
    {
      title: '其中:递延所得税资产减少',
      dataIndex: 'DeferedTaxAssetDecrease',
      key: 'DeferedTaxAssetDecrease',
      indentStep: 1
    },
    {
      title: '递延所得税负债增加',
      dataIndex: 'DeferedTaxLiabilityIncrease',
      key: 'DeferedTaxLiabilityIncrease',
      indentStep: 1
    },
    {
      title: '存货的减少',
      dataIndex: 'InventoryDecrease',
      key: 'InventoryDecrease',
      indentStep: 1
    },
    {
      title: '经营性应收项目的减少',
      dataIndex: 'OperateReceivableDecrease',
      key: 'OperateReceivableDecrease',
      indentStep: 1
    },
    {
      title: '经营性应付项目的增加',
      dataIndex: 'OperatePayableIncrease',
      key: 'OperatePayableIncrease',
      indentStep: 1
    },
    {
      title: '其他',
      dataIndex: 'Others',
      key: 'Others',
      indentStep: 1
    },
    {
      title: '经营活动产生的现金流量净额',
      dataIndex: 'NetOperateCashFlowNotes',
      key: 'NetOperateCashFlowNotes'
    },
    {
      title: '现金的期末余额',
      dataIndex: 'CashAtEndOfYear',
      key: 'CashAtEndOfYear',
      indentStep: 1
    },
    {
      title: '减:现金的期初余额',
      dataIndex: 'CashAtBeginningOfYear',
      key: 'CashAtBeginningOfYear',
      indentStep: 1
    },
    {
      title: '现金及现金等价物的净增加额',
      dataIndex: 'NetIncrInCashAndEquivalents',
      key: 'NetIncrInCashAndEquivalents'
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType'
    }
  ],
  bank: [
    {
      title: '现金流量表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '经营活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '客户存款和同业及其他金融机构存放款项净增加额',
      dataIndex: 'NetDepositIncrease',
      key: 'NetDepositIncrease',
      indentStep: 1
    },
    {
      title: '拆入资金及卖出回购金融资产款净增加额',
      dataIndex: 'LoansIncrease',
      key: 'LoansIncrease',
      indentStep: 1
    },
    {
      title: '收取利息、手续费及佣金的现金',
      dataIndex: 'InterestAndCommissionCashIn',
      key: 'InterestAndCommissionCashIn',
      indentStep: 1
    },
    {
      title: ' 收到其他与经营活动有关的现金',
      dataIndex: 'OtherCashInRelatedOperate',
      key: 'OtherCashInRelatedOperate',
      indentStep: 1
    },
    {
      title: '经营活动现金流入小计',
      dataIndex: 'SubtotalOperateCashInflow',
      key: 'SubtotalOperateCashInflow'
    },
    {
      title: '客户贷款及垫款净增加额',
      dataIndex: 'NetLoanAndAdvanceIncrease',
      key: 'NetLoanAndAdvanceIncrease',
      indentStep: 1
    },
    {
      title: '存放中央银行和同业及其他金融机构款项净增加额',
      dataIndex: 'NetDepositInCBAndIB',
      key: 'NetDepositInCBAndIB',
      indentStep: 1
    },
    {
      title: '拆出资金及买入返售金融资产净增加额',
      dataIndex: 'NetLendCapital',
      key: 'NetLendCapital',
      indentStep: 1
    },
    {
      title: '交易性金融资产净增加额',
      dataIndex: 'NetIncFinAssTraPurp',
      key: 'NetIncFinAssTraPurp',
      indentStep: 1
    },
    {
      title: '支付利息、手续费及佣金的现金',
      dataIndex: 'CommissionCashPaid',
      key: 'CommissionCashPaid',
      indentStep: 1
    },
    {
      title: '支付给职工以及为职工支付的现金',
      dataIndex: 'StaffBehalfPaid',
      key: 'StaffBehalfPaid',
      indentStep: 1
    },
    {
      title: '支付的各项税费',
      dataIndex: 'AllTaxesPaid',
      key: 'AllTaxesPaid',
      indentStep: 1
    },
    {
      title: '支付其他与经营活动有关的现金',
      dataIndex: 'OtherOperateCashPaid',
      key: 'OtherOperateCashPaid',
      indentStep: 1
    },
    {
      title: '经营活动现金流出小计',
      dataIndex: 'SubtotalOperateCashOutflow',
      key: 'SubtotalOperateCashOutflow'
    },
    {
      title: '经营活动产生的现金流量净额',
      dataIndex: 'NetOperateCashFlow',
      key: 'NetOperateCashFlow'
    },
    {
      title: '投资活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '收回投资收到的现金',
      dataIndex: 'InvestWithdrawalCash',
      key: 'InvestWithdrawalCash',
      indentStep: 1
    },
    {
      title: '取得投资收益收到的现金',
      dataIndex: 'Investproceeds',
      key: 'Investproceeds',
      indentStep: 1
    },
    {
      title: '处置固定资产、无形资产和其他长期资产收回的现金净额',
      dataIndex: 'FixIntanOtherAssetDispoCash',
      key: 'FixIntanOtherAssetDispoCash',
      indentStep: 1
    },
    {
      title: '处置子公司、联营企业及合营企业投资及其他企业收到的现金',
      dataIndex: 'NetCashDealSubCompany',
      key: 'NetCashDealSubCompany',
      indentStep: 1
    },
    {
      title: '投资活动现金流入小计',
      dataIndex: 'SubtotalInvestCashInflow',
      key: 'SubtotalInvestCashInflow'
    },
    {
      title: '投资支付的现金',
      dataIndex: 'InvestCashPaid',
      key: 'InvestCashPaid',
      indentStep: 1
    },
    {
      title: '购建固定资产、无形资产和其他长期资产所支付的现金',
      dataIndex: 'FixIntanOtherAssetAcquiCash',
      key: 'FixIntanOtherAssetAcquiCash',
      indentStep: 1
    },
    {
      title: '取得子公司及其他营业单位支付的现金',
      dataIndex: 'NetCashFromSubCompany',
      key: 'NetCashFromSubCompany',
      indentStep: 1
    },
    {
      title: '投资活动现金流出小计',
      dataIndex: 'SubtotalInvestCashOutflow',
      key: 'SubtotalInvestCashOutflow'
    },
    {
      title: '投资活动产生的现金流量净额',
      dataIndex: 'NetInvestCashFlow',
      key: 'NetInvestCashFlow'
    },
    {
      title: '筹资活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '发行债券收到的现金',
      dataIndex: 'CashFromBondsIssue',
      key: 'CashFromBondsIssue',
      indentStep: 1
    },
    {
      title: '收到其他与筹资活动有关的现金',
      dataIndex: 'OtherFinanceActCash',
      key: 'OtherFinanceActCash',
      indentStep: 1
    },
    {
      title: '吸收投资收到的现金',
      dataIndex: 'CashFromInvest',
      key: 'CashFromInvest',
      indentStep: 1
    },
    {
      title: '其中:子公司吸收少数股东投资收到的现金',
      dataIndex: 'CashFromMinoSInvestSub',
      key: 'CashFromMinoSInvestSub',
      indentStep: 1
    },
    {
      title: '筹资活动现金流入小计',
      dataIndex: 'SubtotalFinanceCashInflow',
      key: 'SubtotalFinanceCashInflow'
    },
    {
      title: '偿还债务支付的现金',
      dataIndex: 'BorrowingRepayment',
      key: 'BorrowingRepayment',
      indentStep: 1
    },
    {
      title: '支付其他与筹资活动有关的现金',
      dataIndex: 'OtherFinanceActPayment',
      key: 'OtherFinanceActPayment',
      indentStep: 1
    },
    {
      title: '分配股利、利润或偿付利息支付的现金',
      dataIndex: 'DividendInterestPayment',
      key: 'DividendInterestPayment',
      indentStep: 1
    },
    {
      title: '筹资活动现金流出小计',
      dataIndex: 'SubtotalFinanceCashOutflow',
      key: 'SubtotalFinanceCashOutflow'
    },
    {
      title: '筹资活动产生的现金流量净额',
      dataIndex: 'NetFinanceCashFlow',
      key: 'NetFinanceCashFlow'
    },
    {
      title: '汇率变动对现金及现金等价物的影响',
      dataIndex: 'ExchanRateChangeEffect',
      key: 'ExchanRateChangeEffect'
    },
    {
      title: '现金及现金等价物净增加额',
      dataIndex: 'CashEquivalentIncrease',
      key: 'CashEquivalentIncrease'
    },
    {
      title: '加:期初现金及现金等价物余额',
      dataIndex: 'BeginPeriodCash',
      key: 'BeginPeriodCash',
      indentStep: 1
    },
    {
      title: '期末现金及现金等价物余额',
      dataIndex: 'EndPeriodCashEquivalent',
      key: 'EndPeriodCashEquivalent'
    },
    {
      title: '补充资料',
      dataIndex: '',
      key: ''
    },
    {
      title: '净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit',
      indentStep: 1
    },
    {
      title: '资产减值准备',
      dataIndex: 'AssetsDepreciationReserves',
      key: 'AssetsDepreciationReserves',
      indentStep: 1
    },
    {
      title: '固定资产和投资性房地产折旧',
      dataIndex: 'AssetDepreciation',
      key: 'AssetDepreciation',
      indentStep: 1
    },
    {
      title: '无形资产及长期待摊费用等摊销',
      dataIndex: 'AssetAmortization',
      key: 'AssetAmortization',
      indentStep: 1
    },
    {
      title: '无形资产摊销',
      dataIndex: 'IntangibleAssetAmortization',
      key: 'IntangibleAssetAmortization',
      indentStep: 1
    },
    {
      title: '长期待摊费用摊销',
      dataIndex: 'DeferredExpenseAmort',
      key: 'DeferredExpenseAmort',
      indentStep: 1
    },
    {
      title: '处置固定资产、无形资产和其他长期资产的损失',
      dataIndex: 'FixIntanOtherAssetDispoLoss',
      key: 'FixIntanOtherAssetDispoLoss',
      indentStep: 1
    },
    {
      title: '公允价值变动损失',
      dataIndex: 'LossFromFairValueChanges',
      key: 'LossFromFairValueChanges',
      indentStep: 1
    },
    {
      title: '投资损失',
      dataIndex: 'InvestLoss',
      key: 'InvestLoss',
      indentStep: 1
    },
    {
      title: '递延所得税',
      dataIndex: 'DeferedTaxAsset',
      key: 'DeferedTaxAsset',
      indentStep: 1
    },
    {
      title: '其中:递延所得税资产减少',
      dataIndex: 'DeferedTaxAssetDecrease',
      key: 'DeferedTaxAssetDecrease',
      indentStep: 1
    },
    {
      title: '递延所得税负债增加',
      dataIndex: 'DeferedTaxLiabilityIncrease',
      key: 'DeferedTaxLiabilityIncrease',
      indentStep: 1
    },
    {
      title: '经营性应收项目的减少',
      dataIndex: 'OperateReceivableDecrease',
      key: 'OperateReceivableDecrease',
      indentStep: 1
    },
    {
      title: '经营性应付项目的增加',
      dataIndex: 'OperatePayableIncrease',
      key: 'OperatePayableIncrease',
      indentStep: 1
    },
    {
      title: '其他',
      dataIndex: 'Others',
      key: 'Others',
      indentStep: 1
    },
    {
      title: '经营活动产生的现金流量净额',
      dataIndex: 'NetOperateCashFlowNotes',
      key: 'NetOperateCashFlowNotes'
    },
    {
      title: '现金的期末余额',
      dataIndex: 'CashAtEndOfYear',
      key: 'CashAtEndOfYear',
      indentStep: 1
    },
    {
      title: '减:现金的期初余额',
      dataIndex: 'CashAtBeginningOfYear',
      key: 'CashAtBeginningOfYear',
      indentStep: 1
    },
    {
      title: '加:现金等价物的期末余额',
      dataIndex: 'CashEquivalentsAtEndOfYear',
      key: 'CashEquivalentsAtEndOfYear',
      indentStep: 1
    },
    {
      title: '减:现金等价物的期初余额',
      dataIndex: 'CashEquivalentsAtBeginning',
      key: 'CashEquivalentsAtBeginning',
      indentStep: 1
    },
    {
      title: '现金及现金等价物的净增加额',
      dataIndex: 'NetIncrInCashAndEquivalents',
      key: 'NetIncrInCashAndEquivalents'
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType'
    }
  ],
  bond: [
    {
      title: '现金流量表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '经营活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '收取利息、手续费及佣金的现金',
      dataIndex: 'InterestAndCommissionCashIn',
      key: 'InterestAndCommissionCashIn',
      indentStep: 1
    },
    {
      title: '拆入资金净增加额',
      dataIndex: 'NetIncBorFunds',
      key: 'NetIncBorFunds',
      indentStep: 1
    },
    {
      title: '代理买卖证券收到的现金净额',
      dataIndex: 'NetCashRecInVTS',
      key: 'NetCashRecInVTS',
      indentStep: 1
    },
    {
      title: ' 回购业务资金净增加额',
      dataIndex: 'NetBuyBack',
      key: 'NetBuyBack',
      indentStep: 1
    },
    {
      title: ' 收到其他与经营活动有关的现金',
      dataIndex: 'OtherCashInRelatedOperate',
      key: 'OtherCashInRelatedOperate',
      indentStep: 1
    },
    {
      title: '经营活动现金流入小计',
      dataIndex: 'SubtotalOperateCashInflow',
      key: 'SubtotalOperateCashInflow'
    },
    {
      title: '支付利息、手续费及佣金的现金',
      dataIndex: 'CommissionCashPaid',
      key: 'CommissionCashPaid',
      indentStep: 1
    },
    {
      title: '支付给职工以及为职工支付的现金',
      dataIndex: 'StaffBehalfPaid',
      key: 'StaffBehalfPaid',
      indentStep: 1
    },
    {
      title: '支付的各项税费',
      dataIndex: 'AllTaxesPaid',
      key: 'AllTaxesPaid',
      indentStep: 1
    },
    {
      title: '支付其他与经营活动有关的现金',
      dataIndex: 'OtherOperateCashPaid',
      key: 'OtherOperateCashPaid',
      indentStep: 1
    },
    {
      title: '经营活动现金流出小计',
      dataIndex: 'SubtotalOperateCashOutflow',
      key: 'SubtotalOperateCashOutflow'
    },
    {
      title: '经营活动产生的现金流量净额',
      dataIndex: 'NetOperateCashFlow',
      key: 'NetOperateCashFlow'
    },
    {
      title: '投资活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '收回投资收到的现金',
      dataIndex: 'InvestWithdrawalCash',
      key: 'InvestWithdrawalCash',
      indentStep: 1
    },
    {
      title: '取得投资收益收到的现金',
      dataIndex: 'Investproceeds',
      key: 'Investproceeds',
      indentStep: 1
    },
    {
      title: '处置固定资产、无形资产和其他长期资产收回的现金净额',
      dataIndex: 'FixIntanOtherAssetDispoCash',
      key: 'FixIntanOtherAssetDispoCash',
      indentStep: 1
    },
    {
      title: '处置子公司及其他营业单位收到的现金',
      dataIndex: 'NetCashDealSubCompany',
      key: 'NetCashDealSubCompany',
      indentStep: 1
    },
    {
      title: '投资活动现金流入小计',
      dataIndex: 'SubtotalInvestCashInflow',
      key: 'SubtotalInvestCashInflow'
    },
    {
      title: '投资支付的现金',
      dataIndex: 'InvestCashPaid',
      key: 'InvestCashPaid',
      indentStep: 1
    },
    {
      title: '购建固定资产、无形资产和其他长期资产所支付的现金',
      dataIndex: 'FixIntanOtherAssetAcquiCash',
      key: 'FixIntanOtherAssetAcquiCash',
      indentStep: 1
    },
    {
      title: '支付其他与投资活动有关的现金',
      dataIndex: 'OtherCashToInvestAct',
      key: 'OtherCashToInvestAct',
      indentStep: 1
    },
    {
      title: '投资活动现金流出小计',
      dataIndex: 'SubtotalInvestCashOutflow',
      key: 'SubtotalInvestCashOutflow'
    },
    {
      title: '投资活动产生的现金流量净额',
      dataIndex: 'NetInvestCashFlow',
      key: 'NetInvestCashFlow'
    },
    {
      title: '筹资活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '吸收投资收到的现金',
      dataIndex: 'CashFromInvest',
      key: 'CashFromInvest',
      indentStep: 1
    },
    {
      title: '取得借款收到的现金',
      dataIndex: 'CashFromBorrowing',
      key: 'CashFromBorrowing',
      indentStep: 1
    },
    {
      title: '发行债券收到的现金',
      dataIndex: 'CashFromBondsIssue',
      key: 'CashFromBondsIssue',
      indentStep: 1
    },
    {
      title: '筹资活动现金流入小计',
      dataIndex: 'SubtotalFinanceCashInflow',
      key: 'SubtotalFinanceCashInflow'
    },
    {
      title: '偿还债务支付的现金',
      dataIndex: 'BorrowingRepayment',
      key: 'BorrowingRepayment',
      indentStep: 1
    },
    {
      title: '分配股利、利润或偿付利息支付的现金',
      dataIndex: 'DividendInterestPayment',
      key: 'DividendInterestPayment',
      indentStep: 1
    },
    {
      title: '子公司支付给少数股东的股利、利润',
      dataIndex: 'ProceedsFromSubToMinoS',
      key: 'ProceedsFromSubToMinoS',
      indentStep: 1
    },
    {
      title: '支付其他与筹资活动有关的现金',
      dataIndex: 'OtherFinanceActPayment',
      key: 'OtherFinanceActPayment',
      indentStep: 1
    },
    {
      title: '筹资活动现金流出小计',
      dataIndex: 'SubtotalFinanceCashOutflow',
      key: 'SubtotalFinanceCashOutflow'
    },
    {
      title: '筹资活动产生的现金流量净额',
      dataIndex: 'NetFinanceCashFlow',
      key: 'NetFinanceCashFlow'
    },
    {
      title: '汇率变动对现金及现金等价物的影响',
      dataIndex: 'ExchanRateChangeEffect',
      key: 'ExchanRateChangeEffect'
    },
    {
      title: '现金及现金等价物净增加额',
      dataIndex: 'CashEquivalentIncrease',
      key: 'CashEquivalentIncrease'
    },
    {
      title: '加:期初现金及现金等价物余额',
      dataIndex: 'BeginPeriodCash',
      key: 'BeginPeriodCash',
      indentStep: 1
    },
    {
      title: '期末现金及现金等价物余额',
      dataIndex: 'EndPeriodCashEquivalent',
      key: 'EndPeriodCashEquivalent',
      indentStep: 1
    },
    {
      title: '补充资料',
      dataIndex: '',
      key: ''
    },
    {
      title: '净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit',
      indentStep: 1
    },
    {
      title: '资产减值准备',
      dataIndex: 'AssetsDepreciationReserves',
      key: 'AssetsDepreciationReserves',
      indentStep: 1
    },
    {
      title: '固定资产和投资性房地产折旧',
      dataIndex: 'AssetDepreciation',
      key: 'AssetDepreciation',
      indentStep: 1
    },
    {
      title: '无形资产及长期待摊费用等摊销',
      dataIndex: 'AssetAmortization',
      key: 'AssetAmortization',
      indentStep: 1
    },
    {
      title: '其中:无形资产摊销',
      dataIndex: 'IntangibleAssetAmortization',
      key: 'IntangibleAssetAmortization',
      indentStep: 1
    },
    {
      title: '长期待摊费用摊销',
      dataIndex: 'DeferredExpenseAmort',
      key: 'DeferredExpenseAmort',
      indentStep: 1
    },
    {
      title: '处置固定资产、无形资产和其他长期资产的损失',
      dataIndex: 'FixIntanOtherAssetDispoLoss',
      key: 'FixIntanOtherAssetDispoLoss',
      indentStep: 1
    },
    {
      title: '固定资产报废损失',
      dataIndex: 'FixedAssetScrapLoss',
      key: 'FixedAssetScrapLoss',
      indentStep: 1
    },
    {
      title: '公允价值变动损失',
      dataIndex: 'LossFromFairValueChanges',
      key: 'LossFromFairValueChanges',
      indentStep: 1
    },
    {
      title: '投资损失',
      dataIndex: 'InvestLoss',
      key: 'InvestLoss',
      indentStep: 1
    },
    {
      title: '递延所得税',
      dataIndex: 'DeferedTaxAsset',
      key: 'DeferedTaxAsset',
      indentStep: 1
    },
    {
      title: '其中:递延所得税资产减少',
      dataIndex: 'DeferedTaxAssetDecrease',
      key: 'DeferedTaxAssetDecrease',
      indentStep: 1
    },
    {
      title: '递延所得税负债增加',
      dataIndex: 'DeferedTaxLiabilityIncrease',
      key: 'DeferedTaxLiabilityIncrease',
      indentStep: 1
    },
    {
      title: '交易性金融资产的减少',
      dataIndex: 'NetIncFinAssTraPurp',
      key: 'NetIncFinAssTraPurp',
      indentStep: 1
    },
    {
      title: '经营性应收项目的减少',
      dataIndex: 'OperateReceivableDecrease',
      key: 'OperateReceivableDecrease',
      indentStep: 1
    },
    {
      title: '经营性应付项目的增加',
      dataIndex: 'OperatePayableIncrease',
      key: 'OperatePayableIncrease',
      indentStep: 1
    },
    {
      title: '经营活动产生的现金流量净额',
      dataIndex: 'NetOperateCashFlowNotes',
      key: 'NetOperateCashFlowNotes'
    },
    {
      title: '现金的期末余额',
      dataIndex: 'CashAtEndOfYear',
      key: 'CashAtEndOfYear',
      indentStep: 1
    },
    {
      title: '减:现金的期初余额',
      dataIndex: 'CashAtBeginningOfYear',
      key: 'CashAtBeginningOfYear',
      indentStep: 1
    },
    {
      title: '现金及现金等价物的净增加额',
      dataIndex: 'NetIncrInCashAndEquivalents',
      key: 'NetIncrInCashAndEquivalents'
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType'
    }
  ],
  insurance: [
    {
      title: '现金流量表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '经营活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '收到原保险合同保费取得的现金',
      dataIndex: 'NetOriginalInsuranceCash',
      key: 'NetOriginalInsuranceCash',
      indentStep: 1
    },
    {
      title: ' 保户储金及投资款净增加额',
      dataIndex: 'NetInsurerDepositInvestment',
      key: 'NetInsurerDepositInvestment',
      indentStep: 1
    },
    {
      title: ' 收到交易性金融资产现金净额',
      dataIndex: 'NetDealTradingAssets',
      key: 'NetDealTradingAssets',
      indentStep: 1
    },
    {
      title: ' 收到其他与经营活动有关的现金',
      dataIndex: 'OtherCashInRelatedOperate',
      key: 'OtherCashInRelatedOperate',
      indentStep: 1
    },
    {
      title: '经营活动现金流入小计',
      dataIndex: 'SubtotalOperateCashInflow',
      key: 'SubtotalOperateCashInflow'
    },
    {
      title: '支付原保险合同赔付等款项的现金',
      dataIndex: 'OriginalCompensationPaid',
      key: 'OriginalCompensationPaid',
      indentStep: 1
    },
    {
      title: '支付再保险业务现金净额',
      dataIndex: 'NetCashForReinsurance',
      key: 'NetCashForReinsurance',
      indentStep: 1
    },
    {
      title: '支付利息、手续费及佣金的现金',
      dataIndex: 'CommissionCashPaid',
      key: 'CommissionCashPaid',
      indentStep: 1
    },
    {
      title: '支付保单红利的现金',
      dataIndex: 'PolicyDividendCashPaid',
      key: 'PolicyDividendCashPaid',
      indentStep: 1
    },
    {
      title: '支付给职工以及为职工支付的现金',
      dataIndex: 'StaffBehalfPaid',
      key: 'StaffBehalfPaid',
      indentStep: 1
    },
    {
      title: '支付的各项税费',
      dataIndex: 'AllTaxesPaid',
      key: 'AllTaxesPaid',
      indentStep: 1
    },
    {
      title: '支付交易性金融资产现金净额',
      dataIndex: 'NetIncFinAssTraPurp',
      key: 'NetIncFinAssTraPurp',
      indentStep: 1
    },

    {
      title: '支付其他与经营活动有关的现金',
      dataIndex: 'OtherOperateCashPaid',
      key: 'OtherOperateCashPaid',
      indentStep: 1
    },
    {
      title: '经营活动现金流出小计',
      dataIndex: 'SubtotalOperateCashOutflow',
      key: 'SubtotalOperateCashOutflow'
    },
    {
      title: '经营活动产生的现金流量净额',
      dataIndex: 'NetOperateCashFlow',
      key: 'NetOperateCashFlow'
    },
    {
      title: '投资活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '收回投资收到的现金',
      dataIndex: 'InvestWithdrawalCash',
      key: 'InvestWithdrawalCash',
      indentStep: 1
    },
    {
      title: '取得投资收益收到的现金',
      dataIndex: 'Investproceeds',
      key: 'Investproceeds',
      indentStep: 1
    },
    {
      title: '处置固定资产、无形资产和其他长期资产收回的现金净额',
      dataIndex: 'FixIntanOtherAssetDispoCash',
      key: 'FixIntanOtherAssetDispoCash',
      indentStep: 1
    },
    {
      title: '处置子公司及其他营业单位收到的现金',
      dataIndex: 'NetCashDealSubCompany',
      key: 'NetCashDealSubCompany',
      indentStep: 1
    },
    {
      title: '投资活动现金流入小计',
      dataIndex: 'SubtotalInvestCashInflow',
      key: 'SubtotalInvestCashInflow'
    },
    {
      title: '投资支付的现金',
      dataIndex: 'InvestCashPaid',
      key: 'InvestCashPaid',
      indentStep: 1
    },
    {
      title: '保户质押贷款净增加额',
      dataIndex: 'ImpawnedLoanNetIncrease',
      key: 'ImpawnedLoanNetIncrease',
      indentStep: 1
    },
    {
      title: '购建固定资产、无形资产和其他长期资产所支付的现金',
      dataIndex: 'FixIntanOtherAssetAcquiCash',
      key: 'FixIntanOtherAssetAcquiCash',
      indentStep: 1
    },
    {
      title: '投资活动现金流出小计',
      dataIndex: 'SubtotalInvestCashOutflow',
      key: 'SubtotalInvestCashOutflow'
    },
    {
      title: '投资活动产生的现金流量净额',
      dataIndex: 'NetInvestCashFlow',
      key: 'NetInvestCashFlow'
    },
    {
      title: '筹资活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '吸收投资收到的现金',
      dataIndex: 'CashFromInvest',
      key: 'CashFromInvest',
      indentStep: 1
    },
    {
      title: '取得借款收到的现金',
      dataIndex: 'CashFromBorrowing',
      key: 'CashFromBorrowing',
      indentStep: 1
    },
    {
      title: '收到的其他与筹资活动有关的现金',
      dataIndex: 'OtherFinanceActCash',
      key: 'OtherFinanceActCash',
      indentStep: 1
    },
    {
      title: '筹资活动现金流入小计',
      dataIndex: 'SubtotalFinanceCashInflow',
      key: 'SubtotalFinanceCashInflow'
    },
    {
      title: '偿还债务支付的现金',
      dataIndex: 'BorrowingRepayment',
      key: 'BorrowingRepayment',
      indentStep: 1
    },
    {
      title: '分配股利、利润或偿付利息支付的现金',
      dataIndex: 'DividendInterestPayment',
      key: 'DividendInterestPayment',
      indentStep: 1
    },
    {
      title: '支付卖出回购金融资产款现金净额',
      dataIndex: 'NetBuyBackFin',
      key: 'NetBuyBackFin',
      indentStep: 1
    },
    {
      title: '支付其他与筹资活动有关的现金',
      dataIndex: 'OtherFinanceActPayment',
      key: 'OtherFinanceActPayment',
      indentStep: 1
    },
    {
      title: '筹资活动现金流出小计',
      dataIndex: 'SubtotalFinanceCashOutflow',
      key: 'SubtotalFinanceCashOutflow'
    },
    {
      title: '筹资活动产生的现金流量净额',
      dataIndex: 'NetFinanceCashFlow',
      key: 'NetFinanceCashFlow'
    },
    {
      title: '汇率变动对现金及现金等价物的影响',
      dataIndex: 'ExchanRateChangeEffect',
      key: 'ExchanRateChangeEffect'
    },
    {
      title: '现金及现金等价物净增加额',
      dataIndex: 'CashEquivalentIncrease',
      key: 'CashEquivalentIncrease',
      indentStep: 1
    },
    {
      title: '加:期初现金及现金等价物余额',
      dataIndex: 'BeginPeriodCash',
      key: 'BeginPeriodCash',
      indentStep: 1
    },
    {
      title: '期末现金及现金等价物余额',
      dataIndex: 'EndPeriodCashEquivalent',
      key: 'EndPeriodCashEquivalent'
    },
    {
      title: '补充资料',
      dataIndex: '',
      key: ''
    },
    {
      title: '净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit',
      indentStep: 1
    },
    {
      title: '资产减值准备',
      dataIndex: 'AssetsDepreciationReserves',
      key: 'AssetsDepreciationReserves',
      indentStep: 1
    },
    {
      title: '固定资产和投资性房地产折旧',
      dataIndex: 'AssetDepreciation',
      key: 'AssetDepreciation',
      indentStep: 1
    },
    {
      title: '其中:固定资产折旧',
      dataIndex: 'FixedAssetDepreciation',
      key: 'FixedAssetDepreciation',
      indentStep: 1
    },
    {
      title: '无形资产及长期待摊费用等摊销',
      dataIndex: 'AssetAmortization',
      key: 'AssetAmortization',
      indentStep: 1
    },
    {
      title: '其中:无形资产摊销',
      dataIndex: 'IntangibleAssetAmortization',
      key: 'IntangibleAssetAmortization',
      indentStep: 1
    },
    {
      title: '长期待摊费用摊销',
      dataIndex: 'DeferredExpenseAmort',
      key: 'DeferredExpenseAmort',
      indentStep: 1
    },
    {
      title: '处置固定资产、无形资产和其他长期资产的损失',
      dataIndex: 'FixIntanOtherAssetDispoLoss',
      key: 'FixIntanOtherAssetDispoLoss',
      indentStep: 1
    },
    {
      title: '公允价值变动损失',
      dataIndex: 'LossFromFairValueChanges',
      key: 'LossFromFairValueChanges',
      indentStep: 1
    },
    {
      title: '投资损失',
      dataIndex: 'InvestLoss',
      key: 'InvestLoss',
      indentStep: 1
    },
    {
      title: '递延所得税',
      dataIndex: 'DeferedTaxAsset',
      key: 'DeferedTaxAsset',
      indentStep: 1
    },
    {
      title: '经营性应收项目的减少',
      dataIndex: 'OperateReceivableDecrease',
      key: 'OperateReceivableDecrease',
      indentStep: 1
    },
    {
      title: '经营性应付项目的增加',
      dataIndex: 'OperatePayableIncrease',
      key: 'OperatePayableIncrease',
      indentStep: 1
    },
    {
      title: '经营活动产生的现金流量净额其他项目',
      dataIndex: 'NetOperateCashFlowNotes',
      key: 'NetOperateCashFlowNotes',
      indentStep: 1
    },
    {
      title: '经营活动产生的现金流量净额',
      dataIndex: 'NetOperateCashFlowNotes',
      key: 'NetOperateCashFlowNotes'
    },
    {
      title: '现金的期末余额',
      dataIndex: 'CashAtEndOfYear',
      key: 'CashAtEndOfYear',
      indentStep: 1
    },
    {
      title: '减:现金的期初余额',
      dataIndex: 'CashAtBeginningOfYear',
      key: 'CashAtBeginningOfYear',
      indentStep: 1
    },
    {
      title: '现金及现金等价物的净增加额',
      dataIndex: 'NetIncrInCashAndEquivalents',
      key: 'NetIncrInCashAndEquivalents'
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType'
    }
  ],
  trust: [
    {
      title: '现金流量表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '经营活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '拆入资金及卖出回购金融资产款净增加额',
      dataIndex: 'LoansIncrease',
      key: 'LoansIncrease',
      indentStep: 1
    },
    {
      title: '其中:卖出回购金融资产款净增加额',
      dataIndex: 'NetBuyBackFin',
      key: 'NetBuyBackFin',
      indentStep: 1
    },
    {
      title: '收取利息、手续费及佣金的现金',
      dataIndex: 'InterestAndCommissionCashIn',
      key: 'InterestAndCommissionCashIn',
      indentStep: 1
    },
    {
      title: ' 收到其他与经营活动有关的现金',
      dataIndex: 'OtherCashInRelatedOperate',
      key: 'OtherCashInRelatedOperate',
      indentStep: 1
    },
    {
      title: '经营活动现金流入小计',
      dataIndex: 'SubtotalOperateCashInflow',
      key: 'SubtotalOperateCashInflow'
    },
    {
      title: '客户贷款及垫款净增加额',
      dataIndex: 'NetLoanAndAdvanceIncrease',
      key: 'NetLoanAndAdvanceIncrease',
      indentStep: 1
    },
    {
      title: '交易性金融资产净增加额',
      dataIndex: 'NetIncFinAssTraPurp',
      key: 'NetIncFinAssTraPurp',
      indentStep: 1
    },
    {
      title: '支付利息、手续费及佣金的现金',
      dataIndex: 'CommissionCashPaid',
      key: 'CommissionCashPaid',
      indentStep: 1
    },
    {
      title: '支付给职工以及为职工支付的现金',
      dataIndex: 'StaffBehalfPaid',
      key: 'StaffBehalfPaid',
      indentStep: 1
    },
    {
      title: '支付的各项税费',
      dataIndex: 'AllTaxesPaid',
      key: 'AllTaxesPaid',
      indentStep: 1
    },
    {
      title: '支付其他与经营活动有关的现金',
      dataIndex: 'OtherOperateCashPaid',
      key: 'OtherOperateCashPaid',
      indentStep: 1
    },
    {
      title: '经营活动现金流出小计',
      dataIndex: 'SubtotalOperateCashOutflow',
      key: 'SubtotalOperateCashOutflow'
    },
    {
      title: '经营活动产生的现金流量净额',
      dataIndex: 'NetOperateCashFlow',
      key: 'NetOperateCashFlow'
    },
    {
      title: '投资活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '收回投资收到的现金',
      dataIndex: 'InvestWithdrawalCash',
      key: 'InvestWithdrawalCash',
      indentStep: 1
    },
    {
      title: '取得投资收益收到的现金',
      dataIndex: 'Investproceeds',
      key: 'Investproceeds',
      indentStep: 1
    },
    {
      title: '处置固定资产、无形资产和其他长期资产收回的现金净额',
      dataIndex: 'FixIntanOtherAssetDispoCash',
      key: 'FixIntanOtherAssetDispoCash',
      indentStep: 1
    },
    {
      title: '收到的其他与投资活动有关的现金',
      dataIndex: 'OtherCashFromInvestAct',
      key: 'OtherCashFromInvestAct',
      indentStep: 1
    },
    {
      title: '投资活动现金流入小计',
      dataIndex: 'SubtotalInvestCashInflow',
      key: 'SubtotalInvestCashInflow'
    },
    {
      title: '投资支付的现金',
      dataIndex: 'InvestCashPaid',
      key: 'InvestCashPaid',
      indentStep: 1
    },
    {
      title: '购建固定资产、无形资产和其他长期资产所支付的现金',
      dataIndex: 'FixIntanOtherAssetAcquiCash',
      key: 'FixIntanOtherAssetAcquiCash',
      indentStep: 1
    },
    {
      title: '支付其他与投资活动有关的现金',
      dataIndex: 'OtherCashToInvestAct',
      key: 'OtherCashToInvestAct',
      indentStep: 1
    },
    {
      title: '投资活动现金流出小计',
      dataIndex: 'SubtotalInvestCashOutflow',
      key: 'SubtotalInvestCashOutflow'
    },
    // {
    //   title: '投资支付的现金',
    //   dataIndex: 'InvestCashPaid',
    //   key: 'InvestCashPaid',
    //   indentStep: 1
    // },
    // {
    //   title: '保户质押贷款净增加额',
    //   dataIndex: 'ImpawnedLoanNetIncrease',
    //   key: 'ImpawnedLoanNetIncrease',
    //   indentStep: 1
    // },
    // {
    //   title: '购建固定资产、无形资产和其他长期资产所支付的现金',
    //   dataIndex: 'FixIntanOtherAssetAcquiCash',
    //   key: 'FixIntanOtherAssetAcquiCash',
    //   indentStep: 1
    // },
    {
      title: '投资活动产生的现金流量净额',
      dataIndex: 'NetInvestCashFlow',
      key: 'NetInvestCashFlow'
    },
    {
      title: '筹资活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '收到的其他与筹资活动有关的现金',
      dataIndex: 'OtherFinanceActCash',
      key: 'OtherFinanceActCash',
      indentStep: 1
    },
    {
      title: '筹资活动现金流入小计',
      dataIndex: 'SubtotalFinanceCashInflow',
      key: 'SubtotalFinanceCashInflow'
    },
    {
      title: '支付其他与筹资活动有关的现金',
      dataIndex: 'OtherFinanceActPayment',
      key: 'OtherFinanceActPayment',
      indentStep: 1
    },
    {
      title: '分配股利、利润或偿付利息支付的现金',
      dataIndex: 'DividendInterestPayment',
      key: 'DividendInterestPayment',
      indentStep: 1
    },
    {
      title: '筹资活动现金流出小计',
      dataIndex: 'SubtotalFinanceCashOutflow',
      key: 'SubtotalFinanceCashOutflow'
    },
    {
      title: '筹资活动产生的现金流量净额',
      dataIndex: 'NetFinanceCashFlow',
      key: 'NetFinanceCashFlow'
    },
    {
      title: '现金及现金等价物净增加额',
      dataIndex: 'CashEquivalentIncrease',
      key: 'CashEquivalentIncrease'
    },
    {
      title: '加:期初现金及现金等价物余额',
      dataIndex: 'BeginPeriodCash',
      key: 'BeginPeriodCash',
      indentStep: 1
    },
    {
      title: '期末现金及现金等价物余额',
      dataIndex: 'EndPeriodCashEquivalent',
      key: 'EndPeriodCashEquivalent',
      indentStep: 1
    },
    {
      title: '补充资料',
      dataIndex: '',
      key: ''
    },
    {
      title: '净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit',
      indentStep: 1
    },
    {
      title: '资产减值准备',
      dataIndex: 'AssetsDepreciationReserves',
      key: 'AssetsDepreciationReserves',
      indentStep: 1
    },
    {
      title: '固定资产和投资性房地产折旧',
      dataIndex: 'AssetDepreciation',
      key: 'AssetDepreciation',
      indentStep: 1
    },
    {
      title: '固定资产折旧',
      dataIndex: 'FixedAssetDepreciation',
      key: 'FixedAssetDepreciation',
      indentStep: 1
    },
    {
      title: '无形资产及长期待摊费用等摊销',
      dataIndex: 'AssetAmortization',
      key: 'AssetAmortization',
      indentStep: 1
    },
    {
      title: '无形资产摊销',
      dataIndex: 'IntangibleAssetAmortization',
      key: 'IntangibleAssetAmortization',
      indentStep: 1
    },
    {
      title: '处置固定资产、无形资产和其他长期资产的损失',
      dataIndex: 'FixIntanOtherAssetDispoLoss',
      key: 'FixIntanOtherAssetDispoLoss',
      indentStep: 1
    },
    {
      title: '公允价值变动损失',
      dataIndex: 'LossFromFairValueChanges',
      key: 'LossFromFairValueChanges',
      indentStep: 1
    },
    {
      title: '投资损失',
      dataIndex: 'InvestLoss',
      key: 'InvestLoss',
      indentStep: 1
    },
    {
      title: '递延所得税',
      dataIndex: 'DeferedTaxAsset',
      key: 'DeferedTaxAsset',
      indentStep: 1
    },
    {
      title: '其中:递延所得税资产减少',
      dataIndex: 'DeferedTaxAssetDecrease',
      key: 'DeferedTaxAssetDecrease',
      indentStep: 1
    },
    {
      title: '递延所得税负债增加',
      dataIndex: 'DeferedTaxLiabilityIncrease',
      key: 'DeferedTaxLiabilityIncrease',
      indentStep: 1
    },
    {
      title: '经营性应收项目的减少',
      dataIndex: 'OperateReceivableDecrease',
      key: 'OperateReceivableDecrease',
      indentStep: 1
    },
    {
      title: '经营性应付项目的增加',
      dataIndex: 'OperatePayableIncrease',
      key: 'OperatePayableIncrease',
      indentStep: 1
    },
    {
      title: '经营活动产生的现金流量净额',
      dataIndex: 'NetOperateCashFlowNotes',
      key: 'NetOperateCashFlowNotes'
    },
    {
      title: '现金的期末余额',
      dataIndex: 'CashAtEndOfYear',
      key: 'CashAtEndOfYear',
      indentStep: 1
    },
    {
      title: '减:现金的期初余额',
      dataIndex: 'CashAtBeginningOfYear',
      key: 'CashAtBeginningOfYear',
      indentStep: 1
    },
    {
      title: '现金及现金等价物的净增加额',
      dataIndex: 'NetIncrInCashAndEquivalents',
      key: 'NetIncrInCashAndEquivalents'
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType'
    }
  ],
  others: [
    {
      title: '现金流量表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '经营活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '收取利息、手续费及佣金的现金',
      dataIndex: 'InterestAndCommissionCashIn',
      key: 'InterestAndCommissionCashIn',
      indentStep: 1
    },
    {
      title: ' 收到其他与经营活动有关的现金',
      dataIndex: 'OtherCashInRelatedOperate',
      key: 'OtherCashInRelatedOperate',
      indentStep: 1
    },
    {
      title: '经营活动现金流入小计',
      dataIndex: 'SubtotalOperateCashInflow',
      key: 'SubtotalOperateCashInflow'
    },
    {
      title: '支付给职工以及为职工支付的现金',
      dataIndex: 'StaffBehalfPaid',
      key: 'StaffBehalfPaid',
      indentStep: 1
    },
    {
      title: '支付的各项税费',
      dataIndex: 'AllTaxesPaid',
      key: 'AllTaxesPaid',
      indentStep: 1
    },
    {
      title: '支付其他与经营活动有关的现金',
      dataIndex: 'OtherOperateCashPaid',
      key: 'OtherOperateCashPaid',
      indentStep: 1
    },
    {
      title: '经营活动现金流出小计',
      dataIndex: 'SubtotalOperateCashOutflow',
      key: 'SubtotalOperateCashOutflow'
    },
    {
      title: '经营活动产生的现金流量净额',
      dataIndex: 'NetOperateCashFlow',
      key: 'NetOperateCashFlow'
    },
    {
      title: '投资活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '收回投资收到的现金',
      dataIndex: 'InvestWithdrawalCash',
      key: 'InvestWithdrawalCash',
      indentStep: 1
    },
    {
      title: '取得投资收益收到的现金',
      dataIndex: 'Investproceeds',
      key: 'Investproceeds',
      indentStep: 1
    },
    {
      title: '处置固定资产、无形资产和其他长期资产收回的现金净额',
      dataIndex: 'FixIntanOtherAssetDispoCash',
      key: 'FixIntanOtherAssetDispoCash',
      indentStep: 1
    },
    {
      title: '收到的其他与投资活动有关的现金',
      dataIndex: 'OtherCashFromInvestAct',
      key: 'OtherCashFromInvestAct',
      indentStep: 1
    },
    {
      title: '投资活动现金流入小计',
      dataIndex: 'SubtotalInvestCashInflow',
      key: 'SubtotalInvestCashInflow'
    },
    {
      title: '投资支付的现金',
      dataIndex: 'InvestCashPaid',
      key: 'InvestCashPaid',
      indentStep: 1
    },
    {
      title: '购建固定资产、无形资产和其他长期资产所支付的现金',
      dataIndex: 'FixIntanOtherAssetAcquiCash',
      key: 'FixIntanOtherAssetAcquiCash',
      indentStep: 1
    },

    {
      title: '支付其他与投资活动有关的现金',
      dataIndex: 'OtherCashToInvestAct',
      key: 'OtherCashToInvestAct',
      indentStep: 1
    },
    {
      title: '投资活动现金流出小计',
      dataIndex: 'SubtotalInvestCashOutflow',
      key: 'SubtotalInvestCashOutflow'
    },
    {
      title: '投资活动产生的现金流量净额',
      dataIndex: 'NetInvestCashFlow',
      key: 'NetInvestCashFlow'
    },
    {
      title: '筹资活动产生的现金流量',
      dataIndex: '',
      key: ''
    },
    {
      title: '取得借款收到的现金',
      dataIndex: 'CashFromBorrowing',
      key: 'CashFromBorrowing',
      indentStep: 1
    },
    {
      title: '发行债券收到的现金',
      dataIndex: 'CashFromBondsIssue',
      key: 'CashFromBondsIssue',
      indentStep: 1
    },
    {
      title: '收到的其他与筹资活动有关的现金',
      dataIndex: 'OtherFinanceActCash',
      key: 'OtherFinanceActCash',
      indentStep: 1
    },
    {
      title: '筹资活动现金流入小计',
      dataIndex: 'SubtotalFinanceCashInflow',
      key: 'SubtotalFinanceCashInflow'
    },
    {
      title: '偿还债务支付的现金',
      dataIndex: 'BorrowingRepayment',
      key: 'BorrowingRepayment',
      indentStep: 1
    },
    {
      title: '分配股利、利润或偿付利息支付的现金',
      dataIndex: 'DividendInterestPayment',
      key: 'DividendInterestPayment',
      indentStep: 1
    },
    {
      title: '支付其他与筹资活动有关的现金',
      dataIndex: 'OtherFinanceActPayment',
      key: 'OtherFinanceActPayment',
      indentStep: 1
    },
    {
      title: '筹资活动现金流出的平衡项目',
      dataIndex: 'AdjustmentItemsFCOF',
      key: 'AdjustmentItemsFCOF',
      indentStep: 1
    },
    {
      title: '筹资活动现金流出小计',
      dataIndex: 'SubtotalFinanceCashOutflow',
      key: 'SubtotalFinanceCashOutflow'
    },
    {
      title: '筹资活动产生的现金流量净额平衡项目',
      dataIndex: 'AdjustmentItemsNFCF',
      key: 'AdjustmentItemsNFCF',
      indentStep: 1
    },
    {
      title: '筹资活动产生的现金流量净额',
      dataIndex: 'NetFinanceCashFlow',
      key: 'NetFinanceCashFlow'
    },
    {
      title: '汇率变动对现金及现金等价物的影响',
      dataIndex: 'ExchanRateChangeEffect',
      key: 'ExchanRateChangeEffect'
    },
    {
      title: '现金及现金等价物净增加额',
      dataIndex: 'CashEquivalentIncrease',
      key: 'CashEquivalentIncrease'
    },
    {
      title: '加:期初现金及现金等价物余额',
      dataIndex: 'BeginPeriodCash',
      key: 'BeginPeriodCash',
      indentStep: 1
    },
    {
      title: '期末现金及现金等价物余额平衡项目',
      dataIndex: 'AdjustmentItemsCEI',
      key: 'AdjustmentItemsCEI',
      indentStep: 1
    },
    {
      title: '期末现金及现金等价物余额',
      dataIndex: 'EndPeriodCashEquivalent',
      key: 'EndPeriodCashEquivalent',
      indentStep: 1
    },
    {
      title: '补充资料',
      dataIndex: '',
      key: ''
    },
    {
      title: '净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit',
      indentStep: 1
    },
    {
      title: '资产减值准备',
      dataIndex: 'AssetsDepreciationReserves',
      key: 'AssetsDepreciationReserves',
      indentStep: 1
    },
    {
      title: '固定资产和投资性房地产折旧',
      dataIndex: 'AssetDepreciation',
      key: 'AssetDepreciation',
      indentStep: 1
    },
    {
      title: '无形资产及长期待摊费用等摊销',
      dataIndex: 'AssetAmortization',
      key: 'AssetAmortization',
      indentStep: 1
    },
    {
      title: '其中:无形资产摊销',
      dataIndex: 'IntangibleAssetAmortization',
      key: 'IntangibleAssetAmortization',
      indentStep: 1
    },
    {
      title: '长期待摊费用摊销',
      dataIndex: 'DeferredExpenseAmort',
      key: 'DeferredExpenseAmort',
      indentStep: 1
    },
    {
      title: '处置固定资产、无形资产和其他长期资产的损失',
      dataIndex: 'FixIntanOtherAssetDispoLoss',
      key: 'FixIntanOtherAssetDispoLoss',
      indentStep: 1
    },
    {
      title: '公允价值变动损失',
      dataIndex: 'LossFromFairValueChanges',
      key: 'LossFromFairValueChanges',
      indentStep: 1
    },
    {
      title: '财务费用',
      dataIndex: 'FinancialExpense',
      key: 'FinancialExpense',
      indentStep: 1
    },
    {
      title: '投资损失',
      dataIndex: 'InvestLoss',
      key: 'InvestLoss',
      indentStep: 1
    },
    {
      title: '递延所得税',
      dataIndex: 'DeferedTaxAsset',
      key: 'DeferedTaxAsset',
      indentStep: 1
    },
    {
      title: '其中:递延所得税资产减少',
      dataIndex: 'DeferedTaxAssetDecrease',
      key: 'DeferedTaxAssetDecrease',
      indentStep: 1
    },
    {
      title: '递延所得税负债增加',
      dataIndex: 'DeferedTaxLiabilityIncrease',
      key: 'DeferedTaxLiabilityIncrease',
      indentStep: 1
    },
    {
      title: '存货的减少',
      dataIndex: 'InventoryDecrease',
      key: 'InventoryDecrease',
      indentStep: 1
    },
    {
      title: '经营性应收项目的减少',
      dataIndex: 'OperateReceivableDecrease',
      key: 'OperateReceivableDecrease',
      indentStep: 1
    },
    {
      title: '经营性应付项目的增加',
      dataIndex: 'OperatePayableIncrease',
      key: 'OperatePayableIncrease',
      indentStep: 1
    },
    {
      title: '其他',
      dataIndex: 'Others',
      key: 'Others',
      indentStep: 1
    },
    {
      title: '经营活动产生的现金流量净额其他项目',
      dataIndex: 'NetOperateCashFlowNotes',
      key: 'NetOperateCashFlowNotes',
      indentStep: 1
    },
    {
      title: '经营活动产生的现金流量净额',
      dataIndex: 'NetOperateCashFlowNotes',
      key: 'NetOperateCashFlowNotes'
    },
    {
      title: '现金的期末余额',
      dataIndex: 'CashAtEndOfYear',
      key: 'CashAtEndOfYear',
      indentStep: 1
    },
    {
      title: '减:现金的期初余额',
      dataIndex: 'CashAtBeginningOfYear',
      key: 'CashAtBeginningOfYear',
      indentStep: 1
    },
    {
      title: '加:现金等价物的期末余额',
      dataIndex: 'CashEquivalentsAtEndOfYear',
      key: 'CashEquivalentsAtEndOfYear',
      indentStep: 1
    },
    {
      title: '减:现金等价物的期初余额',
      dataIndex: 'CashEquivalentsAtBeginning',
      key: 'CashEquivalentsAtBeginning',
      indentStep: 1
    },
    {
      title: '现金及现金等价物的净增加额',
      dataIndex: 'NetIncrInCashAndEquivalents',
      key: 'NetIncrInCashAndEquivalents'
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType'
    }
  ]
}

export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, Nodata, DoubleRightOutlined, DoubleLeftOutlined },
  setup(props, context) {
    const myTableBlock = ref(HTMLElement)
    const scrollTable = ref(HTMLElement)
    const tooltip: any = reactive({})
    const overflow: any = reactive({})
    const pageData: any = reactive({
      data: [],
      columns: [],
      tags: [],
      activeTagVal: 1,
      classification: 'ybqy',
      spinning: true,
      leftIconShow: false,
      rightIconShow: true,
      getPopupContainer: (e: HTMLElement) => e.parentNode,
      timer: null
    })
    function handleScroll() {
      const position = (myTableBlock.value as any).scrollLeft
      const clientW = (scrollTable.value as any).childNodes[1].clientWidth
      const target = clientW - 769
      pageData.leftIconShow = position > 0 ? true : false
      pageData.rightIconShow = position >= target ? false : true
    }
    watch(
      () => props.pageSourceData || {},
      (val: any) => {
        switch (val.EnterpriseType) {
          case 99:
            pageData.classification = 'ybqy' // ybqy
            break
          case 13:
            pageData.classification = 'bank'
            break
          case 31:
            pageData.classification = 'bond'
            break
          case 33:
            pageData.classification = 'trust'
            break
          case 35:
            pageData.classification = 'insurance'
            break
          case 39:
            pageData.classification = 'others'
            break
          default:
        }
        const data = JSON.parse(JSON.stringify(val.CashFlow))
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'Debt' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
          pageData.data = data
        }
        nextTick(() => {
          pageData.spinning = false
          if ((pageData.data || []).length === 0) return
          const blockEl: any = myTableBlock.value
          blockEl.scrollLeft = 0
          handleScroll()
        })
      },
      { deep: true }
    )
    pageData.tags = [
      {
        label: '按报告期',
        value: 1
      },
      {
        label: '按年度',
        value: 2
      },
      {
        label: '按单季度',
        value: 3
      },
      {
        label: '报告期同比',
        value: 4
      },
      {
        label: '年度同比',
        value: 5
      },
      {
        label: '单季度环比',
        value: 6
      }
    ]
    pageData.columns = computed(() => {
      return myColumns[pageData.classification]
    })

    async function checkTag(tag: any) {
      pageData.activeTagVal = tag.value
      pageData.data = await getDetail(pageData.activeTagVal)
      nextTick(() => {
        if ((pageData.data || []).length === 0) return
        const blockEl: any = myTableBlock.value
        blockEl.scrollLeft = 0
        handleScroll()
      })
    }
    const route = useRoute()
    function getDetail(type: number) {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        StaticsType: type,
        DataType: 16
      }
      data.headers = {
        token: props.token
      }
      return f10Api.getFinanceF10(data).then((res: any) => {
        const data = JSON.parse(JSON.stringify((res.Data || {}).CashFlow))
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'Debt' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
          // pageData.data = data
        }
        return data
      })
    }
    function scrollToTarget(direction: string) {
      const el: any = scrollTable.value
      const blockEl: any = myTableBlock.value
      const trWidth = (el.childNodes[1] as any).clientWidth // 一行的宽度
      const screenWidth = 1000 - 232 // 1屏
      const columWidth = trWidth / pageData.data.length // 1列
      const originPosition = blockEl.scrollLeft // 原始位置
      const step = screenWidth - columWidth // 每次滚动的距离=1屏-1列
      if (direction === 'left') {
        animateScroll(-step, blockEl)
      } else {
        animateScroll(step, blockEl)
      }
    }
    function animateScroll(step: number, blockEl: any) {
      const target = blockEl.scrollLeft + step
      clearInterval(pageData.timer)
      pageData.timer = setInterval(() => {
        let miniStep = step / 10
        miniStep = miniStep > 0 ? Math.ceil(step) : Math.floor(step)
        if (blockEl.scrollLeft + miniStep < target) {
          blockEl.scrollLeft += miniStep
        } else {
          blockEl.scrollLeft = target
          clearInterval(pageData.timer)
          pageData.timer = null
        }
      }, 20)
    }
    function getOpinion(val: any) {
      let res
      switch (val) {
        case 1:
          res = '无保留'
          break
        case 2:
          res = '无保留带解释性说明'
          break
        case 3:
          res = '保留意见'
          break
        case 4:
          res = '拒绝/无法表示意见'
          break
        case 5:
          res = '否定意见'
          break
        case 6:
          res = '未经审计'
          break
        case 7:
          res = '保留带解释性说明'
          break
        case 10:
          res = '经审计（不确定具体意见类型）'
          break
        default:
          res = '—'
      }
      return res
    }
    let timer: any = null
    function isoverflow(e: any, key: any, t: any) {
      tooltip[key + t] = e.currentTarget.scrollWidth > e.currentTarget.clientWidth
      if (tooltip[key + t]) {
        if (!timer) {
          timer = setTimeout(() => {
            overflow[key + t] = true
          }, 400)
        }
      }
    }
    function hidetool(key: any, t: any) {
      if (timer) {
        setTimeout(() => {
          overflow[key + t] = false
          window.clearTimeout(timer)
          timer = null
        })
      }
    }
    return {
      ...toRefs(pageData),
      tooltip,
      overflow,
      isoverflow,
      hidetool,
      checkTag,
      myTableBlock,
      scrollTable,
      scrollToTarget,
      handleScroll,
      getOpinion
    }
  }
})
